import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../AppConfig';
import Tooltip from '@material-ui/core/Tooltip';
import { CommonStyles } from '../styles/Styles';
import { AppStyles, AppTheme } from '../styles/AppTheme';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { CommonTheme } from '../styles/Styles';

export class AppHelper {
  static buttonEdit(caller, current) {
    return (
      <Tooltip title='Edit' placement='top-start' key={current.id + 'editTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => caller.openModalForEdit(current)}>edit</i>
        </span>
      </Tooltip>
    )
  }

  static buttonDelete(caller, current) {
    return (
      <Tooltip title='Delete' placement='top-start' key={current.id + 'deleteTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => caller.openModalForDelete(current)}>delete</i>
        </span>
      </Tooltip>
    )
  }

  static setDocImage(doc) {
    if (!doc || !doc.docName) {
      return (require('../assets/images/icon-pdf-label.svg'))
    }
    const ext = doc.docName.split('.').pop()
    if (ext === 'pdf') {
      return (require('../assets/images/icon-pdf-label.svg'))
    } else {
      return (require('../assets/images/download.svg'))
    }
  }

  static dictToArray(dic) {
    const arr = []
    for (const key in dic) {
      arr.push(dic[key])
    }
    return arr
  }

  static buttonOpenProduct(caller, current) {
    return (
      <Link to={'/admin/products/' + current.id} key={current.id}>
        <Tooltip title='Open Product' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}><i className='material-icons'>link</i></span>
        </Tooltip>
      </Link>
    )
  }

  static populateOptions(formDefinition, apiResult, key) {
    const options = []
    for (const d of apiResult.items) {
      options.push({
        key: d.id,
        text: d.title
      })
    }
    for (const field of formDefinition.steps[0].fields) {
      if (field.key === key) {
        field.options = options
      }
    }
  }

  static getParamsIdToNameMap(results) {
    if (!results || !results.__resolves || !results.__resolves.cats) {
      return {}
    }

    const paramIdToName = {}

    for (const cat of results.__resolves.cats) {
      if (!cat.params) {
        continue
      }
      for (const key in cat.params) {
        paramIdToName['key_' + key] = cat.params[key].title
      }
    }
    return paramIdToName
  }

  static getProductImages(results) {
    let productImages = []
    if (results && results.images && Object.keys(results.images).length !== 0) {
      productImages = Object.keys(results.images).sort(function (a, b) {
        return results.images[a].order.localeCompare(results.images[b].order);
      }).map(function (k) {
        return results.images[k];
      });
    }
    return productImages
  }

  static sortParamsByOrder(items) {
    return items.sort((a, b) => {
      if (!a.order) {
        return -1
      }
      if (!b.order) {
        return 1
      }
      return Number(a.order) - Number(b.order)
    })
  }

  static sortByName(items) {
    return items.sort((a, b) => {
      const str1 = a.title
      const str2 = b.title
      return str1.localeCompare(str2)
    })
  }

  static convertPaiseToRs(val) {
    return (Number(val) / 100)
  }

  static convertPaiseToRsAfterDiscount(price, discount) {
    return ((Number(price) - Number(discount)) / 100)
  }

  static componentLoadingViewVarient() {
    return (
      <div className={css(Styles.containerVarient)}>
        <CircularProgress size={48} className={css(Styles.progress)} />
      </div>
    )
  }

  static renderCurrencyFormat(price, format) {
    return (
      <NumberFormat
        decimalScale={2}
        fixedDecimalScale={true}
        value={price}
        displayType={'text'}
        thousandSeparator={true}
        renderText={value => <p className={format === 'STRIKE' ? css(Styles.priceStriked) : css(Styles.price)}>{AppConfig.DEFAULT_CURRENCY_SYMBOL} {value}</p>} />
    )
  }

}

const Styles = StyleSheet.create({
  containerVarient: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    height: '60vh',
  },
  progress: {
    color: AppTheme.primaryColor
  },
  price: {
    fontSize: CommonTheme.productDetailsFontSize,
    margin: 0,
    marginRight: 10

  },
  priceStriked: {
    fontSize: CommonTheme.productDetailsFontSize,
    margin: 0,
    marginRight: 10,
    textDecoration: 'line-through'
  },
  priceRangeContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  priceRange: {
    display: 'flex',
  }
})



// WEBPACK FOOTER //
// ./src/helpers/AppHelper.js